/* ═══════════════════════════════════════════════════════════════════════
   CRÉAPANEL — CORRECTIFS & AMÉLIORATIONS
   Fichier : assets/cfg-enhancements.js
   Chargé en différé dans le <head> via snippets/cp-head-extras.liquid :
   exécuté après la lecture de la page, avant DOMContentLoaded et avant le démarrage du
   moteur (window.load) ; rien ici n'a besoin de passer avant configurator-main.js.

   Ce fichier regroupe les correctifs sans toucher au moteur du configurateur :
   1. CFG_UI : messages dans la page (notification + fenêtre « Ajouté au panier ») ;
      échec de l'ajout : message clair selon la cause, sans erreur brute
   2. window.alert remplacé : l'alert natif figeait la page après l'ajout
      au panier (le thème n'a pas de tiroir panier, donc le code tombait
      systématiquement sur alert('Ajouté au panier ✅')).
   3. CART_DEBUG coupé en production (réactivable avec ?cfgdebug=1)
   4. Panier : contrôle d'intégrité du prix avant paiement
   5. Panier : le paramètre ?staff=1 n'affiche plus le bouton staff
   ═══════════════════════════════════════════════════════════════════════*/
(function () {
  'use strict';

  var ACCENT = '#1d4a36';
  var DEBUG = /[?&]cfgdebug=1/.test(location.search);

  /* 5. ?staff=1 : retiré de l'URL avant que la section panier ne le lise */
  try {
    var qs = new URLSearchParams(location.search);
    if (qs.has('staff')) {
      qs.delete('staff');
      var q = qs.toString();
      history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
    }
  } catch (e) {}

  /* 3. CART_DEBUG : configurator-main.js l'assigne, on ne l'expose qu'en debug. : ce fichier est différé,
     le moteur l'a souvent déjà assigné : valeur reprise*/
  try {
    var _cartDebug = window.CART_DEBUG || null;
    Object.defineProperty(window, 'CART_DEBUG', {
      configurable: true,
      get: function () { return DEBUG ? _cartDebug : null; },
      set: function (v) { _cartDebug = v; }
    });
  } catch (e) {}

  /* 1. CFG_UI */
  function injectCss() {
    if (document.getElementById('cfg-ui-css')) return;
    var st = document.createElement('style');
    st.id = 'cfg-ui-css';
    st.textContent =
      '.cfg-toast{position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);z-index:100000;' +
      /*  width max-content, sinon left:50% bornait la largeur à la moitié de l'écran (188 px à 375)*/
      'width:max-content;max-width:min(92vw,460px);padding:14px 18px;border-radius:10px;font-size:14px;line-height:1.45;font-weight:500;color:#fff;' +
      'background:#2b2b2b;box-shadow:0 10px 30px rgba(0,0,0,.2);opacity:0;transition:.25s ease;pointer-events:none}' +
      '.cfg-toast.is-in{opacity:1;transform:translateX(-50%) translateY(0)}' +
      '.cfg-toast--error{background:#b3261e}.cfg-toast--success{background:' + ACCENT + '}' +
      '.cfg-modal-back{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.45);display:flex;align-items:center;' +
      'justify-content:center;padding:16px;opacity:0;transition:opacity .2s}' +
      '.cfg-modal-back.is-in{opacity:1}' +
      '.cfg-modal{background:#fff;border-radius:14px;max-width:440px;width:100%;padding:24px;box-shadow:0 20px 50px rgba(0,0,0,.25);color:#1a1a1a}' +
      '.cfg-modal h3{margin:0 0 4px;font-size:19px;display:flex;align-items:center;gap:10px}' +
      '.cfg-modal h3 .ok{display:inline-flex;width:26px;height:26px;border-radius:50%;background:' + ACCENT + ';color:#fff;align-items:center;justify-content:center;font-size:15px}' +
      '.cfg-modal .sub{margin:0 0 16px;color:#666;font-size:13px}' +
      '.cfg-modal dl{margin:0 0 18px;display:grid;grid-template-columns:auto 1fr;gap:6px 14px;font-size:14px;background:#f6f4ef;border-radius:10px;padding:14px}' +
      '.cfg-modal dt{color:#666}.cfg-modal dd{margin:0;text-align:right;font-weight:600}' +
      '.cfg-modal .actions{display:flex;gap:10px;flex-wrap:wrap}' +
      '.cfg-modal .actions a,.cfg-modal .actions button{flex:1 1 160px;text-align:center;padding:13px 16px;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer;text-decoration:none;border:1px solid ' + ACCENT + '}' +
      '.cfg-modal .btn-primary{background:' + ACCENT + ';color:#fff}.cfg-modal .btn-ghost{background:#fff;color:' + ACCENT + '}' +
      '.cart-u__integrity-err{margin:12px 0;padding:12px 14px;border-radius:8px;background:#fdecea;color:#8a1c14;font-size:14px;line-height:1.45}';
    (document.head || document.documentElement).appendChild(st);
  }

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /*  la notification ne cache jamais la barre de prix du bas (#cp-pricebar, cp-modele), le bouton
     « Ajouter au panier », une fenêtre ou un menu ouverts (A-314 : bulle sur « Appliquer ») ; ni, tant
     qu'une place les évite, un champ, un bouton, une case ou une cote de l'écran (A-314 étendu, AUDIT
     Tour 592 : « Passage étroit… » sur les champs d'angle) : la place la plus basse qui en couvre le moins,
     à 24 px du bas, au-dessus ou au-dessous de chacun, ou en haut de l'écran. Recalculé tant qu'elle est
     affichée (défilement, barre qui apparaît ou disparaît).*/
  var live = [], barSeen = null, banSeen = null, queued = false;
  /* A-336 : bandeau de consentement de Shopify (fixé en bas à la 1re visite, z 2 000 000). La notification ne passe pas
     dessous : elle se place hors de lui, sans couvrir ses boutons, et au-dessus de lui et des parents que les fenêtres et
     les menus ouverts font passer devant lui (z du bandeau + 1). Le bandeau n'est ni fermé ni répondu */
  function banniere() {
    var b = document.getElementById('shopify-pc__banner'); if (!b || !b.getClientRects().length) return null;
    var cs = getComputedStyle(b); if (cs.display === 'none' || cs.visibility === 'hidden') return null;
    var r = b.getBoundingClientRect();
    return r.width > 1 && r.height > 1 && r.bottom > 0 && r.top < window.innerHeight ? { r: r, z: Number(cs.zIndex) || 2000000 } : null;
  }
  function obstacles() {
    var out = [], vh = window.innerHeight, vw = document.documentElement.clientWidth;
    var bar = document.getElementById('cp-pricebar');
    if (bar && bar.classList.contains('is-on') && getComputedStyle(bar).display !== 'none')
      out.push({ top: vh - bar.offsetHeight, bottom: vh, left: 0, right: vw, dur: true });   /* position finale, pas celle de la transition */
    var bn = banniere();
    if (bn) out.push({ top: bn.r.top, bottom: bn.r.bottom, left: bn.r.left, right: bn.r.right, dur: true });
    var prend = function (el, dur) {
      if (!el.getClientRects().length || el.closest('.cfg-toast, #cp-pricebar')) return;
      var r = el.getBoundingClientRect();
      if (r.width > 1 && r.height > 1 && r.bottom > 0 && r.top < vh) out.push({ top: r.top, bottom: r.bottom, left: r.left, right: r.right, dur: dur });
    };
    var add = document.getElementById('btn-add-cart');
    if (add) prend(add, true);
    Array.prototype.forEach.call(document.querySelectorAll('#edge-dims-popup:not(.hidden), #edge-menu:not(.hidden), .config-popup.is-open'), function (p) { prend(p, true); });
    Array.prototype.forEach.call(document.querySelectorAll('input:not([type="hidden"]), select, textarea, button, [role="button"], a[href], .edge-checkbox-container, #dims .dim .label'), function (c) { prend(c, false); });
    return out;
  }
  function place(el) {
    var vh = window.innerHeight, h = el.offsetHeight, rr = el.getBoundingClientRect(), obs = obstacles();
    var couvre = function (b) {                                 /* b : écart au bas de l'écran ; aire couverte, infinie sur un obstacle à ne jamais couvrir */
      var top = vh - b - h, bot = vh - b, c = 0;
      for (var i = 0; i < obs.length; i++) {
        var o = obs[i];
        if (!(top < o.bottom && bot > o.top && rr.left < o.right && rr.right > o.left)) continue;
        if (o.dur) return Infinity;
        c += (Math.min(bot, o.bottom) - Math.max(top, o.top)) * (Math.min(rr.right, o.right) - Math.max(rr.left, o.left));
      }
      return c;
    };
    var cands = [24, vh - h - 12];
    obs.forEach(function (o) { cands.push(vh - o.top + 12, vh - o.bottom - h - 12); });
    cands = cands.filter(function (b) { return b >= 8 && vh - b - h >= 8; }).sort(function (a, b) { return a - b; });
    var bon = null, moins = Infinity;
    cands.forEach(function (b) { var c = couvre(b); if (c < moins) { moins = c; bon = b; } });
    el.style.bottom = (bon == null ? Math.max(8, vh - h - 12) : bon) + 'px';
    var bn = banniere();
    el.style.zIndex = bn ? String(bn.z + 2) : '';
  }
  function placeLater() {
    if (queued || !live.length) return; queued = true;
    requestAnimationFrame(function () { queued = false; live.forEach(place); });
  }
  window.addEventListener('scroll', placeLater, { passive: true });
  window.addEventListener('resize', placeLater);

  /* A-339 (AUDIT Tours 629 et 638) : la bulle d'une action précédente ne reste pas affichée pendant une fenêtre ou un menu
     ouverts après elle (badge, cote, découpe, étagère, menu d'un coin, menus de la barre) : elle se retire à l'ouverture.
     Ce qui s'ouvre dans le même geste qu'elle (la bulle qui dit pourquoi un menu n'offre pas un choix) est relevé avec elle,
     à sa création et deux images plus tard. Une fenêtre fermée puis rouverte est une ouverture nouvelle. Une bulle posée
     pendant une fenêtre (refus d'APPLIQUER) reste, hors d'elle (A-314) */
  var FENETRES_BULLE = '#edge-dims-popup:not(.hidden), #edge-menu:not(.hidden), .config-popup.is-open, #cp-dec-dlg, #cp-etag-dlg:not([hidden])';
  var veille = null, veilleQ = false;
  function ouvertes() {
    return Array.prototype.filter.call(document.querySelectorAll(FENETRES_BULLE), function (f) { return f.getClientRects().length && getComputedStyle(f).visibility !== 'hidden'; });
  }
  function finVeille() { if (!live.length && veille) { veille.disconnect(); veille = null; } }
  function verifieFenetres() {
    veilleQ = false;
    var ouv = ouvertes();
    live.slice().forEach(function (el) {
      if (!el.__cfgFen) return;                                       /* encore dans son geste */
      el.__cfgFen = el.__cfgFen.filter(function (f) { return ouv.indexOf(f) >= 0; });
      if (ouv.some(function (f) { return el.__cfgFen.indexOf(f) < 0; })) { el.remove(); live = live.filter(function (x) { return x !== el; }); }
    });
    finVeille();
  }
  function veilleFenetres(el) {
    var f0 = ouvertes();
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.__cfgFen = f0.concat(ouvertes().filter(function (f) { return f0.indexOf(f) < 0; })); }); });
    if (veille || typeof MutationObserver !== 'function') return;
    veille = new MutationObserver(function () { if (veilleQ) return; veilleQ = true; requestAnimationFrame(verifieFenetres); });
    veille.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
  }

  function toast(msg, type, ms) {
    injectCss();
    var el = document.createElement('div');
    el.className = 'cfg-toast cfg-toast--' + (type || 'info');
    el.setAttribute('role', type === 'error' ? 'alert' : 'status');
    el.textContent = msg;
    document.body.appendChild(el);
    var bar = document.getElementById('cp-pricebar');
    if (bar && bar !== barSeen && typeof MutationObserver === 'function') {
      barSeen = bar; new MutationObserver(placeLater).observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
    var ban = document.getElementById('shopify-pc__banner');               /* A-336 : bandeau qui s'ouvre ou se ferme pendant la bulle */
    if (ban && ban !== banSeen && typeof MutationObserver === 'function') {
      banSeen = ban; new MutationObserver(placeLater).observe(ban, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    /* A-314 : une fenêtre ou un menu qui s'ouvre après la bulle (badge, cote) : la bulle se replace hors de lui */
    if (typeof MutationObserver === 'function') Array.prototype.forEach.call(document.querySelectorAll('#edge-dims-popup, #edge-menu, .config-popup'), function (p) {
      if (p.__cfgVu) return; p.__cfgVu = true;
      new MutationObserver(placeLater).observe(p, { attributes: true, attributeFilter: ['class', 'style'] });
    });
    live.push(el); place(el); veilleFenetres(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    setTimeout(function () {
      el.classList.remove('is-in');
      setTimeout(function () { el.remove(); live = live.filter(function (x) { return x !== el; }); finVeille(); }, 300);
    }, ms || 4500);
  }

  function added(rows, sub) {                                  /* sub : sous-titre*/
    injectCss();
    var old = document.querySelector('.cfg-modal-back');
    if (old) old.remove();
    var back = document.createElement('div');
    back.className = 'cfg-modal-back';
    var dl = (rows || []).filter(function (r) { return r && r[1]; })
      .map(function (r) { return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>'; }).join('');
    back.innerHTML =
      '<div class="cfg-modal" role="dialog" aria-modal="true" aria-labelledby="cfg-added-title">' +
      '<h3 id="cfg-added-title"><span class="ok" aria-hidden="true">✓</span>Ajouté à votre panier</h3>' +
      '<p class="sub">' + esc(sub || 'Votre pièce sur mesure est enregistrée avec toutes ses cotes.') + '</p>' +
      (dl ? '<dl>' + dl + '</dl>' : '') +
      '<div class="actions">' +
      '<button type="button" class="btn-ghost" data-cfg-close>Continuer mes achats</button>' +
      '<a href="/cart" class="btn-primary">Voir mon panier</a>' +
      '</div></div>';
    var opener = document.activeElement;
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      /*  le Tab reste dans la fenêtre, entre « Continuer mes achats » et « Voir mon panier »*/
      if (e.key !== 'Tab') return;
      var f = back.querySelectorAll('button, a[href]'); if (!f.length) return;
      var first = f[0], last = f[f.length - 1], cur = document.activeElement;
      if (!back.contains(cur)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
      else if (e.shiftKey && cur === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
    }
    function close() {
      back.classList.remove('is-in');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { back.remove(); }, 200);
      /*  focus rendu au bouton d'ajout (Échap, « Continuer mes achats », clic à côté),
         sinon à l'élément qui l'avait à l'ouverture ; body n'est plus la destination*/
      var b = document.getElementById('btn-add-cart');
      var to = (b && !b.disabled && b.getClientRects().length) ? b : (opener && opener !== document.body && opener.isConnected ? opener : null);
      if (to) try { to.focus(); } catch (e) {}
    }
    back.addEventListener('click', function (e) {
      if (e.target === back || e.target.closest('[data-cfg-close]')) close();
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(back);
    requestAnimationFrame(function () { back.classList.add('is-in'); });
    var primary = back.querySelector('.btn-primary');
    if (primary) primary.focus();
  }

  /* Récapitulatif lu dans le panneau du configurateur au moment de l'ajout */
  function configuratorSummary() {
    function txt(id) { var el = document.getElementById(id); return el ? el.innerText.trim() : ''; }
    var forme = (document.querySelector('#td-forme .td-forme-text') || {}).textContent || txt('td-forme');
    var finition = '';
    var qty = '';
    try {
      /* App est un const global (pas window.App) : on le lit par son nom */
      var A = (typeof App !== 'undefined') ? App : window.App;
      if (A && A.variantsMeta && A.S) {
        finition = (A.variantsMeta[A.S.variant] || {}).name || '';
        qty = String(A.S.orderQty || 1);
      }
    } catch (e) {}
    var jonction = '';                                             /*  jonction choisie (cp-jonction)*/
    try { if (typeof window.CP_jonction === 'function') jonction = window.CP_jonction() || ''; } catch (e) {}
    return [
      ['Forme', (forme || '').trim()],
      ['Jonction', jonction],
      ['Finition', finition],
      ['Épaisseur', txt('td-epaisseur')],
      /*  même libellé que le récapitulatif (« Surface totale » pour un panneau vendu au m², posé par cp-modele) ;
         lu par textContent (innerText rendait les capitales du CSS : « SURFACE TOTALE ») ; « ML » du moteur en « ml »*/
      [((document.getElementById('recap-length-label') || {}).textContent || '').trim() || 'Longueur totale',
        txt('quantite_dimensions').replace(/\bML\b/, 'ml')],
      ['Quantité', qty],
      ['Prix unitaire', txt('td-prix-total')]
    ];
  }

  /* A-314 : retire les bulles affichées (celles d'un choix précédent, avant la fenêtre du suivant) */
  function efface() {
    live.forEach(function (el) { el.remove(); });
    live = [];
    finVeille();
  }

  window.CFG_UI = { toast: toast, added: added, efface: efface };

  /*  échec de l'ajout au panier. Le moteur passe l'erreur brute (« Failed to fetch »,
     message anglais de l'API, page HTML entière d'une erreur 500) : elle n'est plus montrée. Seule une
     phrase de Shopify en français (422 : stock, quantité…) reste entre parenthèses. Statut de la
     dernière requête /cart/add relevé au passage (fetch inchangé sinon).*/
  var cartStatus = 0;
  try {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') window.fetch = function (u) {
      var p = nativeFetch.apply(window, arguments);
      try {
        if (/\/cart\/add/.test(String(u && u.url ? u.url : u))) {
          cartStatus = 0;
          p.then(function (r) { cartStatus = r.status; }, function () { cartStatus = -1; });
        }
      } catch (e) {}
      return p;
    };
  } catch (e) {}
  function cartError(detail) {
    var d = String(detail || '').trim(), base = 'L\'ajout au panier n\'a pas abouti. ';
    if (cartStatus === -1 || /failed to fetch|load failed|networkerror|network request failed/i.test(d)) return base + 'Vérifiez votre connexion internet, puis réessayez.';
    if (cartStatus === 429 || /too many requests|throttl/i.test(d)) return base + 'Patientez quelques secondes, puis réessayez.';
    var fr = d.length > 0 && d.length <= 300 && d.indexOf('<') < 0 &&
      /[àâçéèêëîïôûùœ]|\b(le|la|les|des|du|votre|vous|est|sont|plus|pas)\b/i.test(d) &&
      !/\b(the|is|are|was|required|invalid|missing|error|not|cannot|parameter|requests?)\b/i.test(d);
    return base + 'Réessayez ou contactez-nous.' + (fr ? ' (' + d + ')' : '');
  }

  /* 2. alert() natif → messages dans la page */
  var nativeAlert = window.alert ? window.alert.bind(window) : null;
  window.alert = function (msg) {
    try {
      var m = String(msg == null ? '' : msg);
      if (/^Ajouté au panier/i.test(m)) { added(configuratorSummary()); return; }
      if (/^Erreur ajout au panier/i.test(m)) {
        toast(cartError(m.replace(/^Erreur ajout au panier\s*:\s*/i, '')), 'error', 7000);
        return;
      }
      if (/^Variante Shopify introuvable/i.test(m)) {                       /*  sans jargon*/
        toast('Cette finition n\'est pas disponible pour le moment : choisissez-en une autre ou contactez-nous.', 'error', 7000);
        return;
      }
      var isError = /erreur|doit être|indisponible|introuvable|impossible/i.test(m);
      toast(m.replace(/Choisis une/g, 'Choisissez une'), isError ? 'error' : 'info', isError ? 6000 : 4500);
    } catch (e) {
      if (nativeAlert) nativeAlert(msg);
    }
  };

  /* 4. Panier : contrôle d'intégrité du prix avant paiement.
     Chaque pièce configurée porte son prix unitaire calculé (_prix_total)
     et sa quantité (_qte_commande). On vérifie que la ligne + ses
     suppléments (_parent_uid) couvrent ce montant. Garde-fou navigateur :
     le contrôle des commandes en admin reste la vérification finale. */
  function parseEuroCents(t) {
    if (!t) return null;
    t = String(t).replace(/[^\d,.\-]/g, '');
    if (t.indexOf(',') > -1) t = t.replace(/\./g, '').replace(',', '.');
    var v = parseFloat(t);
    return isFinite(v) ? Math.round(v * 100) : null;
  }

  function checkCartIntegrity() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var bad = [];
        items.forEach(function (it) {
          var p = it.properties || {};
          if (String(p._addon) === '1' || !p._UID || !p._prix_total) return;
          var unit = parseEuroCents(p._prix_total);
          if (unit == null) return;
          var expected = unit * (parseInt(p._qte_commande, 10) || 1);
          var actual = it.final_line_price;
          items.forEach(function (ad) {
            var ap = ad.properties || {};
            if (String(ap._addon) === '1' && ap._parent_uid === p._UID) actual += ad.final_line_price;
          });
          if (actual + 100 < expected) bad.push(it.product_title); /* tolérance 1 € */
        });
        return { ok: bad.length === 0, bad: bad };
      })
      .catch(function () { return { ok: true, bad: [] }; });
  }

  function showIntegrityError(form, btn, bad) {
    injectCss();
    var box = form.querySelector('.cart-u__integrity-err');
    if (!box) {
      box = document.createElement('p');
      box.className = 'cart-u__integrity-err';
      box.setAttribute('role', 'alert');
      if (btn && btn.parentNode) btn.parentNode.insertBefore(box, btn);
      else form.appendChild(box);
    }
    box.textContent = 'Le prix de « ' + (bad.join(' », « ') || 'une pièce') + ' » ne correspond plus à sa configuration ' +
      '(un supplément a été retiré ou une quantité modifiée). Supprimez la pièce et reconfigurez-la, ou contactez-nous.';
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  window.CFG_UI.checkCart = checkCartIntegrity;

  /* Écoute en CAPTURE sur document : passe avant le gestionnaire de la section panier */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('cart-u__form')) return;
    var btn = e.submitter;
    if (!btn || btn.name !== 'checkout') return;
    /* Contrôle déjà validé il y a moins de 15 s : on laisse passer (la section enchaîne son propre re-clic) */
    if (Date.now() - Number(btn.dataset.integrityOkAt || 0) < 15000) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    checkCartIntegrity().then(function (res) {
      if (!res.ok) { showIntegrityError(form, btn, res.bad); return; }
      btn.dataset.integrityOkAt = String(Date.now());
      btn.click();
    });
  }, true);
})();
